import { IApp } from "@API/Apps/types";
import {
  combineReducers,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  appsListFail,
  appsListRequest,
  appsListSuccess,
  createAppFail,
  createAppRequest,
  createAppSuccess,
  getAppPolicyFail,
  getAppPolicyRequest,
  getAppPolicySuccess,
  resetCreateAppModal,
  setModalCreateApp,
  AppPolicyData,
} from "./actions";

interface IAppsListState {
  list: IApp[];
  isLoading: boolean;
  success: boolean;
  fail: boolean;
}

const APPS_LIST_INITIAL_STATE: IAppsListState = {
  list: [],
  isLoading: false,
  success: false,
  fail: false,
};

const appsListReducer = createReducer(APPS_LIST_INITIAL_STATE, {
  [appsListRequest.type]: (state) => ({
    ...state,
    isLoading: true,
    success: false,
    fail: false,
  }),
  [appsListSuccess.type]: (state, { payload }: PayloadAction<IApp[]>) => ({
    ...state,
    list: payload,
    isLoading: false,
    success: true,
    fail: false,
  }),
  [appsListFail.type]: (state) => ({
    ...state,
    isLoading: false,
    success: false,
    fail: true,
  }),
  [createAppSuccess.type]: (state, { payload }: PayloadAction<IApp>) => ({
    ...state,
    list: [...state.list, payload],
  }),
});

interface ICreateAppModalState {
  isVisible: boolean;
  isLoading: boolean;
}

const CREATE_APP_MODAL_INITIAL_STATE: ICreateAppModalState = {
  isVisible: false,
  isLoading: false,
};

const createAppModalReducer = createReducer(CREATE_APP_MODAL_INITIAL_STATE, {
  [setModalCreateApp.type]: (state) => ({
    ...state,
    isVisible: true,
  }),
  [resetCreateAppModal.type]: () => CREATE_APP_MODAL_INITIAL_STATE,
  [createAppRequest.type]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [createAppSuccess.type]: () => CREATE_APP_MODAL_INITIAL_STATE,
  [createAppFail.type]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

interface IAppPolicyState {
  data: AppPolicyData | null;
  isLoading: boolean;
}

const APP_POLICY_INITIAL_STATE: IAppPolicyState = {
  data: null,
  isLoading: false,
};

const appPolicyReducer = createReducer(APP_POLICY_INITIAL_STATE, {
  [getAppPolicyRequest.type]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [getAppPolicySuccess.type]: (state, { payload }: PayloadAction<AppPolicyData>) => ({
    data: payload,
    isLoading: false,
  }),
  [getAppPolicyFail.type]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

export interface IAppsState {
  readonly list: IAppsListState;
  readonly createModal: ICreateAppModalState;
  readonly policy: IAppPolicyState;
}

export default combineReducers<IAppsState>({
  list: appsListReducer,
  createModal: createAppModalReducer,
  policy: appPolicyReducer,
});
